import React from 'react';
import CorporateLocations from '@stone/components/corporate/CorporateLocations';
const CorporateLocationsLoader = (props) => {
    const locationData = JSON.parse(props.locations);
    let aggregationType = locationData.some((location) => typeof location.tabid !== 'undefined') ? 'tab' : 'country';
    let hasmissingtab = false;
    let locationResult = {
        countries: {},
        tabs: {},
    };
    locationData.forEach((location) => {
        let cid = location.countryid || 'row' + Math.random().toString(16).slice(2);
        locationResult.countries[cid] = locationResult.countries[cid] || {
            id: cid,
            title: location.countryname,
            locations: [],
        };
        locationResult.countries[cid].title = locationResult.countries[cid].title || location.countryname;
        locationResult.countries[cid].locations.push(location);
        if (aggregationType == 'tab') {
            let tid = location.tabid;
            if (tid) {
                locationResult.tabs[tid] = locationResult.tabs[tid] || {
                    id: tid,
                    title: location.tabname,
                    countries: {},
                };
                locationResult.tabs[tid].title = locationResult.tabs[tid].title || location.tabname;
                locationResult.tabs[tid].countries[cid] = locationResult.countries[cid];
            }
            else {
                hasmissingtab = true;
            }
        }
    });
    return (React.createElement(React.Fragment, null,
        hasmissingtab && props.editmode && (React.createElement("span", { style: { backgroundColor: 'yellow', position: 'absolute', padding: 4, marginTop: -30, fontWeight: 700 } }, "SONE LOCATION HAS MISSING TAB ID!")),
        React.createElement(CorporateLocations, { headingindex: parseInt(props.headingindex), aggregationType: aggregationType, locations: locationResult })));
};
export default CorporateLocationsLoader;
